import * as types from './mutation-types'
import client from '@/base/api/client'

export default {
  login: ({ commit, state }, authInfo) => {
    return client.auth({ data: { auth: { api: 'AuthService.frameShopLogin', input: authInfo } } })
      .then((data) => {
        if (data.auth.output) {
          localStorage.setItem('fs_user', data.auth.output.username)
          localStorage.setItem('fs_user_id', data.auth.output.id)
          localStorage.setItem('fs_token', '2')
          localStorage.setItem('fs_user_role', data.auth.output.role)
          commit(types.AUTH_LOGIN, localStorage.getItem('fs_token'))
        }
      })
      .catch(err => { throw err })
  },
  logout: ({ commit, state }) => {
    localStorage.removeItem('fs_user')
    localStorage.removeItem('fs_user_id')
    localStorage.removeItem('fs_token')
    localStorage.removeItem('fs_user_role')
    commit(types.AUTH_LOGOUT, null)
    return client.auth({ data: { auth: {api: 'AuthService.frameShopLogout'} } })
  },
  initUser: ({ commit, state }) => {
    return client.auth({ data: { auth: { api: 'AuthService.frameShopGetLoginUser', input: {} } } })
      .then((data) => {
        if (data.auth.output) {
          localStorage.setItem('fs_user', data.auth.output.username)
          localStorage.setItem('fs_user_id', data.auth.output.id)
          localStorage.setItem('fs_token', '2')
          localStorage.setItem('fs_user_role', data.auth.output.role)
          commit(types.AUTH_LOGIN, localStorage.getItem('fs_token'))
        } else {
          localStorage.removeItem('fs_user')
          localStorage.removeItem('fs_user_id')
          localStorage.removeItem('fs_token')
          localStorage.removeItem('fs_user_role')
          commit(types.AUTH_LOGIN, null)
        }
        return data.auth.output
      })
  }
}
